import axios from 'axios';
import Vue from 'vue'

export default {

    countSharedDocument(){
        return axios.get('/api/shared-documents/countSharedDocument')
        .then((response) => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSharedDocumentsByType(page, pageSize, documentType) {
        return axios.get('/api/shared-documents/list', { params : {page:page, pageSize:pageSize ,documentType: documentType}  })
        .then((response) => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

  
    importDocuments(formData){
        return axios.post('/api/shared-documents/import', formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then((response) => {
            Vue.prototype.$snotify.success("Import des documents terminé");
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadSharedDocument(fileName) {
        axios({
            url: '/api/shared-documents/download',
            method: 'GET',
            params: { name: fileName },
            responseType: 'blob'
        })
        .then((response) => {
            if (!response || !response.data) {
            Vue.prototype.$snotify.error("Aucune donnée reçue");
            return;
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            setTimeout(() => {
            window.URL.revokeObjectURL(url);
            }, 1000);

        })
        .catch(() => {
            Vue.prototype.$snotify.error("Erreur lors de l'ouverture du document");
        });
        },

    setIsSmallAnnouncement(page, pageSize, documentType, sharedDocumentId, isSmallAnnouncement, isActive) {
        return axios.get('/api/shared-documents/set/isSmallAnnouncement', { params : {page:page, pageSize:pageSize ,documentType: documentType , sharedDocumentId:sharedDocumentId, isSmallAnnouncement:isSmallAnnouncement, isActive:isActive}  })
        .then((response) => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    deleteSharedDocument(page, pageSize, documentType, sharedDocumentId){
        return axios.get('/api/shared-documents/delete', { params : {page:page, pageSize:pageSize ,documentType: documentType, sharedDocumentId:sharedDocumentId}  })
        .then((response) => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



}

